const { ToggleControl } = wp.components;

const CarControls = props => {
	
	const { attributes, setAttributes } = props;
	
	return (
		<p>
			<ToggleControl
			    label={ "Enable Carousel Controls" }
			    checked={ attributes.loop }
			    onChange={ (controlVal) => setAttributes({controls: controlVal} ) }
			/>
		</p>
	)
}

export default CarControls;